import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services';
import { UserRole } from '@ml/core/types/enums';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private router: Router, private userService: UserService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const user = this.userService.user;

    if (user.role === UserRole.ADMIN) {
      return true;
    }

    if (user.role === UserRole.CUSTOMER) {
      this.router.navigate(['customer-orders']);
    } else {
      this.router.navigate(['tasks']);
    }

    return false;
  }
}
